import {forwardRef, useContext} from 'react'

import PropTypes from 'prop-types'

import Button from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount/index.js'
import MoleculeNotification, {AUTO_CLOSE, BRDS_SIZE, TYPES} from '@s-ui/react-molecule-notification'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {labelLiterals, phoneErrorTypes, scrollToElement} from './utils.js'

const NotificationDraftErrors = forwardRef(({draftError, hasFormErrors = false, formErrors}, errorNotificationRef) => {
  const {i18n} = useContext(Context)

  useMount(() => {
    if (errorNotificationRef?.current) {
      errorNotificationRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
      errorNotificationRef.current.focus()
    }
  })

  return (
    <MoleculeNotification
      autoClose={AUTO_CLOSE.manual}
      type={TYPES.error}
      showCloseButton={false}
      roundedCorners={BRDS_SIZE.medium}
    >
      <div role="alert" ref={errorNotificationRef} tabIndex="0">
        {hasFormErrors ? (
          <>
            <TitleBasic
              as={titleBasicTags.h2}
              color={titleBasicColors.white}
              size={titleBasicSizes.xxs}
              title={i18n.t('PUBLISH_AD.ERROR.LABEL')}
            />
            <ul>
              {formErrors
                ? formErrors.map((fieldError, index) => {
                    const fieldName = phoneErrorTypes.includes(fieldError) ? 'phone' : fieldError
                    return (
                      <li key={`${fieldName}${index}`}>
                        <Button
                          href={`#${fieldName}`}
                          link
                          negative
                          onClick={event => {
                            event.preventDefault()
                            scrollToElement(fieldName)
                          }}
                        >
                          {i18n.t(labelLiterals[fieldName], 1)}
                        </Button>
                      </li>
                    )
                  })
                : null}
            </ul>
          </>
        ) : (
          <span>{i18n.t(draftError)}</span>
        )}
      </div>
    </MoleculeNotification>
  )
})

NotificationDraftErrors.propTypes = {
  draftError: PropTypes.string,
  hasFormErrors: PropTypes.bool,
  formErrors: PropTypes.arrayOf(PropTypes.string)
}

NotificationDraftErrors.displayName = 'NotificationDraftErrors'

export default NotificationDraftErrors
